/**
 * Represents a record of a link template in the system.
 */
export interface ILinkTemplateRecord {
  id: string;
  appId: string;
  name: string;
  note: string;
  type: string;
  template?: IAdLinkTemplate | IQuickLinkTemplate;
  templateCount: number;
  created: Date;
  createdByEmail: string;
  createdById: string;
  createdByName: string;
}

/**
 * Represents the `nameLinkTemplate` structure for an Ad Link Template.
 */
export interface IAdLinkTemplate {
  nameLinkTemplate: {
    linkTitle: {
      valueType: 'any';
      required: true;
    };
    adPartner: IAdPartner;
    adLinkType: IAdLinkType;
    osType: IBaseField;
    originalWebURL: IBasicField;
    householdMeasurement: HouseholdMeasurementOption;
  };
  analyticsTags: {
    channel: IBasicField;
    campaign: IBasicField;
    tags: IBasicField;
  };
  redirects: IRedirects;
  linkData: ILinkData[];
}

/**
 * Represents the `nameLinkTemplate` structure for a Quick Link Template.
 */
export interface IQuickLinkTemplate {
  nameLinkTemplate: {
    linkTitle: {
      valueType: 'any';
      required: true;
    };
    linkAlias: {
      valueType: 'any';
      required: boolean;
    };
    originalWebURL: IBasicField;
  };
  analyticsTags: {
    feature: IBasicField;
    channel: IBasicField;
    campaign: IBasicField;
    tags: IBasicField;
  };
  redirects: IRedirects & {
    webOnlyLink: string;
  };
  linkData: ILinkData[];
  socialMediaTags: {
    title: IBasicField;
    description: IBasicField;
    imageUrl: IBasicField;
  };
}

/**
 * Represents options for household measurement checkbox.
 */

export enum HouseholdMeasurementOption {
  True = 'true',
  False = 'false',
  Either = 'either',
}

/**
 * Represents the base structure for a field.
 */
interface IBaseField {
  valueType: string;
  value?: any;
  required: boolean;
}

/**
 * Represents a basic field, extending the base field structure.
 */
interface IBasicField extends IBaseField {}

/**
 * Represents the configuration for an ad partner.
 */
interface IAdPartner {
  required: true;
  valueType: 'any' | 'suggestions' | 'fixed' | 'choose';
  value?: any;
}

/**
 * Represents the configuration for an ad link type.
 */
interface IAdLinkType {
  required: true;
  valueType: 'any' | 'suggestions' | 'fixed' | 'choose';
  value?: any;
}

/**
 * Represents the configuration for a redirect field.
 */
interface IRedirectField {
  redirectType: 'Any' | 'Default' | 'WebUrl' | 'Deepview';
  valueType: string;
  value?: any;
  required: boolean;
}

/**
 * Represents the redirects configuration.
 */
interface IRedirects {
  ios: IRedirectField;
  android: IRedirectField;
  desktop: IRedirectField;
}

/**
 * Represents a single link data field.
 */
interface ILinkData {
  fieldName: string;
  valueType: string;
  value?: any;
  required: boolean;
}
